import './facelift/darkMode.st.css';
import './facelift/BadgeIndicator.st.css';
import './facelift/CounterBadge.st.css';
import { st, classes } from './facelift.st.css';
export default (function (_ref) {
  var darkMode = _ref.darkMode;
  return st(classes.root, {
    darkMode: darkMode
  });
});